import Colors from "../assets/constants/Colors";
import { Spacers } from "../assets/constants/Spacers";
import CardsGrid from "../components/CardsGrid";
import styled from "../styled-components";
import { appReviewCovers } from "./Home.constants";
const { pageContent } = Spacers;

const Home = () => {
  const sections = appReviewCovers.map((appReviewCover) => {
    const { title, cards } = appReviewCover;
    return (
      <PageSectionContainer>
        <SectionTitleText>{title}</SectionTitleText>
        <CardsGrid cards={cards}/>
      </PageSectionContainer>
    );
  })
  return (
    <PageContainer>
      <PageContentContainer>
        {sections}
      </PageContentContainer>
    </PageContainer>
  );
};
export default Home;

export const cardStyles = {
  alignItems: "center",
  backgroundColor: Colors.surfaceForeground,
  borderColor: Colors.surfaceForegroundBorder,
  marginBottom: "15px",
};

const PageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const PageContentContainer = styled.div`
  max-width: ${pageContent.maxWidth.px};
  margin: 0 auto;
  padding: ${pageContent.padding.top.px} ${pageContent.padding.horizontal.px} ${pageContent.padding.bottom.px};
  overflow: auto;
  width: 100%;
`;

const PageSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 25px;
`;

const SectionTitleText = styled.h2``;

const BodyText = styled.p``;
